
import MainLayout from "@/components/layout/MainLayout";
import { SEO } from "@/components/seo/SEO";
import { DashboardGenerator } from "@/components/dashboard/DashboardGenerator";
import { DashboardTemplates } from "@/components/dashboard/DashboardTemplates";
import { CustomizableWidgets } from "@/components/dashboard/CustomizableWidgets";
import { DashboardSuggestionsAI } from "@/components/ai/DashboardSuggestionsAI";
import QuickActions from "@/components/dashboard/QuickActions";
import { ExportOptions } from "@/components/exports/ExportOptions";
import { DynamicDashboard } from "@/components/dashboard/DynamicDashboard";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SourceScopedDashboard } from "@/components/dashboard/SourceScopedDashboard";
import { useSearchParams } from "react-router-dom";

const Dashboards = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const sourceId = searchParams.get("sourceId");
  const sourceName = searchParams.get("sourceName") || "your data";

  return (
    <MainLayout>
      <SEO title="Dashboards — Veylo AI" description="Generate AI dashboards, use ready-made templates and build custom KPI, bar, line and pie widgets from your live data." path="/dashboards" />
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Dashboards</h1>
        <p className="text-muted-foreground mb-6">
          Visualize your data with interactive dashboards, charts, and insights.
        </p>

        {sourceId && (
          <SourceScopedDashboard
            sourceId={sourceId}
            sourceName={sourceName}
            onClear={() => setSearchParams({})}
          />
        )}

        
        <Tabs defaultValue="generator" className="w-full">
          <TabsList className="grid w-full grid-cols-2 md:grid-cols-4">
            <TabsTrigger value="generator">Dashboard Generator</TabsTrigger>
            <TabsTrigger value="templates">Templates</TabsTrigger>
            <TabsTrigger value="widgets">Widgets</TabsTrigger>
            <TabsTrigger value="dynamic">Studio</TabsTrigger>
          </TabsList>
          
          <TabsContent value="generator" className="space-y-6">
            <DashboardGenerator />
            <DashboardSuggestionsAI />
          </TabsContent>
          
          <TabsContent value="templates" className="space-y-6">
            <DashboardTemplates />
          </TabsContent>
          
          <TabsContent value="widgets" className="space-y-6">
            <CustomizableWidgets />
            <QuickActions />
          </TabsContent>
          
          <TabsContent value="dynamic" className="space-y-6">
            <DynamicDashboard />
            <ExportOptions />
          </TabsContent>
        </Tabs>
      </div>
    </MainLayout>
  );
};

export default Dashboards;
